import React, { useState } from "react";
import { Download } from "react-feather";
import { connect } from "react-redux";
import { Card, CardBody } from "reactstrap";

import { FilterOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Input,
  message,
  Pagination,
  Row,
  Select,
  Space,
  Table,
  Tag
} from "antd";
import axios from "axios";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { H5 } from "../../../../AbstractElements";
import {
  EstimatePdfOpenApi,
  OrganisationUsers
} from "../../../../api";
import {
  changeEstimateStatus,
  fetchBranchEstimatesList,
  fetchEstimateRevisionData,
} from "../../../../api/estimate.api";
import { fetchProjects } from "../../../../api/project.api";
import { LoggerContext } from "../../../../context/logging";
import DeliveryDrawer from "../Estimate/deliveryDrawer";

const BranchEstimate = (props) => {
  const [estimates, setEstimates] = React.useState([]);
  const [createdByMembers, setCreatedByMembers] = useState([]);
  const [search, setSearch] = useState("");
  const logger = React.useContext(LoggerContext);
  const { Option } = Select;
  let isFirst = true;

  const [page, setPage] = useState(1);
  const [members, setMembers] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [revisionData, setRevisionData] = useState(null);
  const [loading, setLoading] = React.useState(true);
  const history = useNavigate();
  const [estimateRevisionDrawer, setEstimateRevisionDrawer] = useState(false);
  const [tableFilters, setTableFilters] = useState({});
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [projects, setProjects] = useState([]);
  const [showDeliveryDrawer, setShowDeliveryDrawer] = useState(false);
  const [currentEstimate, setCurrentEstimate] = useState(null);

  const { state: filters } = useLocation();

  const fetchMembers = (params = {}) => {
    axios.get(`${OrganisationUsers}`).then((res) => {
      setMembers(res.data);
    });
  };

  const onDeliveryFinish = (deliveryValues) => {
    changeEstimateStatus({
      estimate_id: currentEstimate?.id,
      data: {
        estimate_status: currentEstimate?.estimate_status,
        ...deliveryValues,
      },
    })
      .then((res) => {
        message.success("Delivery status updated successfully");
        setShowDeliveryDrawer(false);
        fetchEstimates(props.settings?.project?.id);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  React.useEffect(() => {
    setTableFilters({
      ...tableFilters,
      ...filters,
    });
    console.log("debug>>> filters to be applied", filters);
  }, [filters]);

  const statusOptions = [
    { id: "1", value: "draft", label: "Draft" },
    {
      id: "2",
      value: "pricing_and_availability_check",
      label: "Pricing and Availability Check",
    },
    {
      id: "3",
      value: "availability_check",
      label: "Availability Check",
    },
    {
      id: "4",
      value: "quote_approval_pending",
      label: "Quote Approval pending",
    },
    {
      id: "5",
      value: "quotation_approved",
      label: "Quotation Approved - Initiate Delivery",
    },
    {
      id: "6",
      value: "order_lost",
      label: "Order Lost",
    },
    {
      id: "7",
      value: "vendor_po_raised",
      label: "Vendor Po Raised",
    },
    {
      id: "8",
      value: "dispatched",
      label: "Dispatched",
    },
    {
      id: "9",
      value: "delivered",
      label: "Delivered",
    },
  ];

  const getFormattedDate = (date) => {
    const formattedDate =
      // moment(date).format("ddd") +
      // " " +
      moment(date).format("MMM") +
      " " +
      moment(date).format("DD") +
      " " +
      moment(date).format("YYYY");

    return formattedDate;
  };

  const goToProject = (project) => {
    const { dispatch } = props;

    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "project",
        value: project,
      },
    });
    dispatch({
      type: "settings/CHANGE_SETTING",
      payload: {
        setting: "projectSelected",
        value: true,
      },
    });
  };
  const columns = [
    {
      title: "Lead ID",
      key: "lead_id",
      dataIndex: "lead_id",
      width: 160,
      sorter: (a, b) => {
        return a.lead_id.localeCompare(b.lead_id);
      },
    },
    {
      title: "Pro Forma Invoice No.",
      key: "estimate_no",
      dataIndex: "estimate_no",
      sorter: (a, b) => {
        return a.estimate_no.localeCompare(b.estimate_no);
      },
    },
    {
      title: "Project",
      key: "lead_id",
      render: (data) => <>{data?.project?.project_name}</>,
    },
    {
      title: "Creation date",
      key: "creation_date",
      dateFormat: "MMM DD YYYY",
      render: (data) => <>{getFormattedDate(data?.created_at)}</>,
      sorter: (a, b) => {
        return a.created_at.localeCompare(b.created_at);
      },
    },
    {
      title: "Created by",
      key: "created_by",
      dataIndex: "created_by",
      // filters: members.map((member) => ({
      //   text: member?.user_organisation?.user?.name,
      //   value: member?.user_organisation?.user?.id,
      // })),
      // onFilter: (value, record) => {
      //   setTableFilters({ ...tableFilters, created_by: value });
      //   console.log(
      //     "debug>>>",
      //     record.created_by ===
      //       members.find((m) => m?.user_organisation?.user?.id === value)
      //         ?.user_organisation?.user?.name
      //   );
      //   return (
      //     record.created_by ===
      //     members.find((m) => m?.user_organisation?.user?.id === value)
      //       ?.user_organisation?.user?.name
      //   );
      // },
      // filterMultiple: true,
    },
    {
      title: "Assigned to",
      key: "assigned_to",
      render: (data) => <>{data?.assigned_to?.name}</>,
    },
    {
      title: "Status",
      key: "status",
      width: 200,
      render: (data) => (
        <Select
          className="w-100"
          key={"estimate_status"}
          defaultValue={data?.estimate_status ?? "draft"}
          value={data?.estimate_status ?? "draft"}
          onChange={(e) => {
            setLoading(true);
            if (
              statusOptions.findIndex((x) => x.value === e) >=
                statusOptions.findIndex(
                  (x) => x.value === "quotation_approved"
                ) &&
              !data?.ship_address &&
              e !== "order_lost"
            ) {
              // Show the delivery drawer
              setShowDeliveryDrawer(true);
              setCurrentEstimate({
                ...data,
                estimate_status: e,
              });
            } else {
              changeEstimateStatus({
                estimate_id: data.id,
                data: { estimate_status: e },
              })
                .then((res) => {
                  fetchEstimates({});
                })
                .finally(() => {
                  setLoading(false);
                });
            }
          }}
        >
          {statusOptions?.map((each, index) => (
            <Option
              // disabled={
              //   index <
              //   statusOptions.findIndex(
              //     (status) => status.value === data?.estimate_status
              //   )
              // }
              value={each?.value}
              key={each?.id}
            >
              {each?.label}
            </Option>
          ))}
        </Select>
      ),
    },
    // {
    //   title: "Revision No.",
    //   key: "revision_no",
    //   dataIndex: "revision_no",
    // },
    {
      title: "Total",
      key: "total_estimate_amount",
      render: (data) => (
        <>{parseFloat(data?.total_estimate_amount ?? 0)?.toFixed(2)}</>
      ),
      sorter: (a, b) => {
        return a.total_estimate_amount?.localeCompare(b.total_estimate_amount);
      },
    },
    {
      title: "Actions",
      key: "actions",
      width: 200,
      render: (data) => {
        return (
          <Row>
            <Tag
              className="mr-1"
              onClick={() => {
                // setModal2Visible(true);
                // setPoDetails(data);
                goToProject(data.project);

                message.loading({
                  content: "Action in progress..",
                  duration: 1,
                  key: "duplicate",
                });
                setTimeout(() => {
                  message.success({
                    content: "Opened invoice",
                    duration: 1,
                    key: "duplicate",
                  });
                  history("/app/project/estimate-details/" + data?.id);
                }, 500);
              }}
              // color={"blue"}
              style={{ cursor: "pointer" }}
            >
              See Details
            </Tag>
            <Download
              className="mr-1"
              onClick={() => {
                // setModal2Visible(true);
                // setPoDetails(data);
                // history("/app/project/estimate-details/" + data?.id);
                window.open(EstimatePdfOpenApi + data?.id, "_blank");
              }}
            />
            {/* <Copy
              onClick={() => {
                message.loading({
                  content: "Action in progress..",
                  duration: 30,
                  key: "duplicate",
                });
                createEstimateDuplicate(data?.id).then((res) => {
                  if (res) {
                    message.success({
                      type: "success",
                      content: "Duplicate created successfully",
                      duration: 2,
                      key: "duplicate",
                    });
                  } else {
                    message.warning({
                      type: "warning",
                      content: "Something went wrong please try again later.",
                      duration: 2,
                      key: "duplicate",
                    });
                  }
                  fetchBranchEstimatesList()
                    .then((res) => {
                      let final_data = res.map((item) => {
                        if (item.estimate?.length > 0) {
                          return { ...item, children: item.estimate };
                        } else {
                          return item;
                        }
                      });
                      setEstimates(final_data);
                      setLoading(false);
                    })
                    .catch(() => {
                      setEstimates([]);
                      setLoading(false);
                    });
                });
              }}
            /> */}
          </Row>
        );
      },
    },
    {
      title: "See revisions",
      key: "revisions",
      render: (data) => {
        return (
          <Tag
            onClick={() => {
              setEstimateRevisionDrawer(true);
              fetchEstimateRevisionData(data.estimate_no).then((res) => {
                setRevisionData(res?.reverse());
              });
            }}
            color={"orange"}
            style={{ cursor: "pointer" }}
          >
            See Revisions
          </Tag>
        );
      },
    },
  ];

  const fetchEstimates = ({ params = { page: page } }) => {
    console.log("fetchEstimates ", params);
    setLoading(true);
    fetchBranchEstimatesList({
      params: {
        ...params,
        ...(tableFilters ?? {}),
      },
    })
      .then((res) => {
        let createdByList = [];
        setTotalPages(res?.count ?? 10);
        let final_data = res?.results?.map((item) => {
          if (
            createdByList.findIndex(
              (member) => member.text == item.created_by__name
            ) < 0
          ) {
            createdByList.push({
              text: item.created_by__name,
              value: item.created_by__name,
            });
          }
          if (item.estimate?.length > 0) {
            return { ...item, children: item.estimate };
          } else {
            return item;
          }
        });
        setEstimates(final_data);

        setCreatedByMembers(createdByList);
        setLoading(false);
      })
      .catch(() => {
        setEstimates([]);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    console.log("fetchEstimates page", props.settings?.project?.id, page);
    fetchEstimates({});
  }, [props.settings?.project?.id, page]);

  React.useEffect(() => {
    fetchMembers();
  }, [props.settings?.project?.id]);

  React.useEffect(() => {
    if (Object.keys(tableFilters).length > 0) {
      fetchEstimates({});
    }
  }, [tableFilters]);

  React.useEffect(() => {
    fetchProjects({ branch: props?.settings?.branch?.id })
      .then((res) => {
        setProjects(res);
      })
      .catch(() => {
        // Do nothing !!! yay :)
      });
  }, [props?.settings?.branch?.id]);

  const membersOptions = React.useMemo(() => {
    return members?.map((member) => ({
      label: member?.user?.name,
      value: member?.user?.id,
    }));
  }, [members]);

  return (
    <section>
      <Card>
        <CardBody>
          <div class="d-flex align-center justify-content-between w-100 mb-2">
            <H5>Pro Forma Invoices</H5>
            <Space>
              <Button onClick={() => setShowFilterPanel((p) => !p)}>
                <FilterOutlined />
              </Button>
              <Input.Search
                type="text"
                style={{ maxWidth: 180 }}
                placeholder="Search"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onSearch={(value) => {
                  fetchEstimates({ params: { search: search } });
                }}
              />
            </Space>
          </div>
          {showFilterPanel && (
            <Space className="my-2">
              <div>
                <DatePicker
                  placeholder="Select Creation Date"
                  style={{ width: 200 }}
                  onChange={(date, dateString) => {
                    setTableFilters({
                      ...tableFilters,
                      created_at: dateString,
                    });
                  }}
                  value={
                    tableFilters?.created_at && moment(tableFilters?.created_at)
                  }
                  onClear={() => {
                    const { created_at, ...rest } = tableFilters;
                    setTableFilters(rest);
                  }}
                />
                <br />
                <span
                  className="text-muted mt-1"
                  style={{
                    fontSize: "75%",
                  }}
                >
                  Creation Date
                </span>
              </div>
              <div>
                <Select
                  placeholder="Select Created By"
                  style={{ width: 200 }}
                  onChange={(value) => {
                    setTableFilters({
                      ...tableFilters,
                      created_by: value,
                    });
                  }}
                  value={tableFilters?.created_by}
                  options={membersOptions}
                  allowClear
                  onClear={() => {
                    const { created_by, ...rest } = tableFilters;
                    setTableFilters(rest);
                  }}
                />
                <br />
                <span
                  className="text-muted mt-1"
                  style={{
                    fontSize: "75%",
                  }}
                >
                  Created By
                </span>
              </div>
              <div>
                <Select
                  placeholder="Select Assigned To"
                  style={{ width: 200 }}
                  onChange={(value) => {
                    setTableFilters({
                      ...tableFilters,
                      assigned_to: value,
                    });
                  }}
                  value={tableFilters?.assigned_to}
                  options={membersOptions}
                  allowClear
                  onClear={() => {
                    const { assigned_to, ...rest } = tableFilters;
                    setTableFilters(rest);
                  }}
                />
                <br />
                <span
                  className="text-muted mt-1"
                  style={{
                    fontSize: "75%",
                  }}
                >
                  Assigned To
                </span>
              </div>
              <div>
                <Select
                  placeholder="Select Status"
                  style={{ width: 200 }}
                  onChange={(value) => {
                    setTableFilters({
                      ...tableFilters,
                      estimate_status: value,
                    });
                  }}
                  value={tableFilters?.estimate_status}
                  options={statusOptions}
                  allowClear
                  onClear={() => {
                    const { estimate_status, ...rest } = tableFilters;
                    setTableFilters(rest);
                  }}
                />
                <br />
                <span
                  className="text-muted mt-1"
                  style={{
                    fontSize: "75%",
                  }}
                >
                  Status
                </span>
              </div>
              <div>
                <Select
                  placeholder="Select Project"
                  style={{ width: 200 }}
                  onChange={(value) => {
                    setTableFilters({
                      ...tableFilters,
                      project: value,
                    });
                  }}
                  value={tableFilters?.project}
                  options={projects?.map((project) => ({
                    label: project?.project_name,
                    value: project?.id,
                  }))}
                  allowClear
                  onClear={() => {
                    const { project, ...rest } = tableFilters;
                    setTableFilters(rest);
                  }}
                />
                <br />
                <span
                  className="text-muted mt-1"
                  style={{
                    fontSize: "75%",
                  }}
                >
                  Project
                </span>
              </div>
            </Space>
          )}
          <Table
            columns={columns}
            loading={loading}
            dataSource={estimates}
            pagination={false}
            rowKey={"id"}
          />

          <Pagination
            current={page}
            total={totalPages}
            showSizeChanger={false}
            className="mt-3"
            onChange={(p) => {
              setPage(p);
            }}
          />
        </CardBody>
      </Card>

      <Drawer
        title={"Pro Forma Invoice Details"}
        width={800}
        onClose={() => {
          setEstimateRevisionDrawer(false);
        }}
        visible={estimateRevisionDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          ></div>
        }
      >
        {!revisionData && <div className="mt-2">Loading...</div>}
        {revisionData?.map((data, index) => {
          return (
            <Card key={(index + Math.random())?.toString()}>
              <CardBody>
                <Row>
                  <Col sm={12} style={{ margin: "auto" }}>
                    <Col sm={24}>
                      <Col
                        style={{
                          fontSize: "12px",
                          color: "#928d8d",
                          fontWeight: "500",
                        }}
                      >
                        Lead Id{" "}
                      </Col>
                      <Col className="fw-bold" style={{ fontSize: "22px" }}>
                        {data?.lead_id}
                      </Col>
                    </Col>
                    <Col
                      sm={24}
                      style={{
                        fontSize: "14px",
                        color: "#928d8d",
                        fontWeight: "500",
                      }}
                    >
                      Created by{" "}
                      <span className="fw-bold" style={{ color: "#000" }}>
                        {" "}
                        {data?.revised_by__name}{" "}
                      </span>
                    </Col>{" "}
                    <Col
                      sm={12}
                      style={{
                        fontSize: "14px",
                        color: "#928d8d",
                        fontWeight: "500",
                      }}
                    >
                      Created at:
                      <span className="fw-bold" style={{ color: "#000" }}>
                        {getFormattedDate(data?.modified_at)}
                      </span>
                    </Col>{" "}
                    <Col sm={20}>
                      <Button
                        onClick={(e) => {
                          goToProject(data.project);

                          message.loading({
                            content: "Action in progress..",
                            duration: 1,
                            key: "duplicate",
                          });
                          setTimeout(() => {
                            message.success({
                              content: "Opened invoice",
                              duration: 1,
                              key: "duplicate",
                            });
                            history(
                              "/app/project/estimate-details/" + data?.id
                            );
                          }, 500);
                        }}
                        type="primary"
                        className="btn d-flex align-items-center justify-content-center border go-to-po-btn"
                      >
                        <div
                          style={{
                            marginLeft: "4px",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                          }}
                        >
                          See Estimate
                        </div>
                      </Button>
                    </Col>
                  </Col>
                  <Col sm={12}>
                    <div style={{ height: 42 }}></div>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Pro Forma Invoice No:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {data?.estimate_no}{" "}
                        {data?.revision && `(R${data?.revision})`}
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Status:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        <Tag
                          style={{ textTransform: "capitalize" }}
                          color={data?.status == "draft" ? "gold" : "green"}
                        >
                          {data.status ?? "Raised"}
                        </Tag>
                      </Col>
                    </Row>
                    <Row className="px-2">
                      <Col sm={12} className="" style={{ color: "#928d8d" }}>
                        Total:{" "}
                      </Col>
                      <Col sm={12} className="text-right">
                        {Number(data?.total_estimate_amount)?.toFixed(2)}
                      </Col>
                    </Row>

                    <Row
                      style={{
                        background: "#f2f2f2",
                        padding: "2px 10px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Col sm={12} className="" style={{ fontSize: "12px" }}>
                        Inclusive of all taxes
                      </Col>
                      <Col
                        sm={12}
                        className="text-right fw-bold"
                        style={{ fontSize: "25px" }}
                      >
                        {"₹"}
                        {Number(data?.total_estimate_amount)?.toFixed(2)}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          );
        })}
      </Drawer>

      <DeliveryDrawer
        onClose={(unsetLoading = false) => {
          setShowDeliveryDrawer(false);
          if (unsetLoading) {
            setLoading(false);
          }
        }}
        visible={showDeliveryDrawer}
        onFinish={onDeliveryFinish}
        deliveryDetails={{
          delivery_poc: estimates,
        }}
      />
    </section>
  );
};

const mapStateToProps = ({ dispatch, settings }) => {
  return {
    dispatch,
    settings,
  };
};

export default connect(mapStateToProps)(BranchEstimate);
